import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App.js";
import "./style.css";

const root = document.getElementById("root");
ReactDOM.render(<App />, root)